import React from 'react';

const PerfilCarousel = ({ perfil }) => {
  const perfiles = {
    comunicativo: {
      title: 'Perfil Comunicativo',
      description:
        'Análisis detallado de las necesidades comunicativas y recomendaciones específicas para potenciar el desarrollo comunicativo del niño.',
      terapias: [
        'Terapia del lenguaje: fortalece la comunicación verbal, gestual y comprensiva.',
        'Musicoterapia: estimula la expresión emocional mediante sonidos, melodías y ritmo.',
        'Sistema PECS (Comunicación por Intercambio de Imágenes): permite al niño iniciar comunicación usando tarjetas visuales estructuradas.'
      ],
      profesionales: [
        'Fonoaudiólogo o terapeuta del lenguaje.',
        'Terapeuta ocupacional con formación en comunicación aumentativa o alternativa (CAA).'
      ],
      casa: [
        'Utiliza frases simples y claras en actividades cotidianas (ej: "Vamos a comer", "Dame la taza").',
        'Apóyate en pictogramas o secuencias visuales para anticipar rutinas.',
        'Refuerza cualquier intento de comunicación con atención, elogios o actividades favoritas.'
      ]
    },
    interactivo: {
      title: 'Perfil Interactivo-Social',
      description:
        'Orientaciones para mejorar la interacción social del niño mediante el juego, la expresión emocional y el reconocimiento de conductas sociales.',
      terapias: [
        'Terapia basada en habilidades sociales: enseña cómo iniciar conversaciones, turnarse y reconocer emociones.',
        'Modelo DENVER (Early Start Denver Model): intervención naturalista centrada en la interacción y el juego.',
        'Terapia cognitivo-conductual adaptada: ayuda a entender emociones y mejorar la autorregulación.'
      ],
      profesionales: [
        'Psicólogo infantil especializado en autismo.',
        'Terapeuta ocupacional con enfoque en juego social.',
        'Educador diferencial con experiencia en inclusión.'
      ],
      casa: [
        'Promueve juegos simbólicos con turnos (ej: juegos de roles).',
        'Narra lo que el niño hace: “Estás armando la torre, qué buena idea”.',
        'Usa historias sociales o cuentos para enseñar cómo actuar en distintas situaciones.'
      ]
    },
    mixto: {
      title: 'Perfil Mixto (Comunicativo + Interacción Social)',
      description:
        'El perfil mixto requiere un abordaje integral que combine terapias comunicativas y de interacción social para lograr un desarrollo equilibrado.',
      terapias: [
        'ABA (Análisis Conductual Aplicado): intervenciones estructuradas para moldear habilidades de comunicación e interacción.',
        'Terapia ocupacional con integración sensorial: mejora la respuesta a estímulos sensoriales y favorece el aprendizaje.',
        'Terapia de juego estructurado: combina objetivos comunicativos y sociales mediante actividades dirigidas.'
      ],
      profesionales: [
        'Equipo multidisciplinario: fonoaudiólogo, psicólogo, terapeuta ocupacional.',
        'Centros especializados como centros de atención temprana o de integración sensorial.'
      ],
      casa: [
        'Establece rutinas visuales con horarios ilustrados o pictogramas.',
        'Combina momentos de juego libre con juego dirigido (ej: armar bloques por colores).',
        'Refuerza con atención positiva y juegos que le gusten.'
      ]
    }
  };

  const perfilData = perfiles[perfil];
  if (!perfilData) return null;

  return (
    <div className="bg-white rounded-2xl shadow-md p-6 md:p-10 space-y-10">
      <div className="bg-blue-600 text-white rounded-xl p-6">
        <h2 className="text-xl md:text-2xl font-bold flex items-center gap-2">
          {perfilData.title}
        </h2>
        <p className="text-sm md:text-base mt-2 text-justify">
          {perfilData.description}
        </p>
      </div>

      <div className="space-y-6">
        <section>
          <h3 className="text-base md:text-lg font-semibold flex items-center gap-2 text-blue-800">
            Terapias recomendadas
          </h3>
          <ul className="list-disc list-inside text-gray-700 text-sm md:text-base mt-2">
            {perfilData.terapias.map((item, i) => (
              <li key={i} className="text-justify">{item}</li>
            ))}
          </ul>
        </section>

        <div className="grid md:grid-cols-2 gap-8">
          <section>
            <h3 className="text-base md:text-lg font-semibold flex items-center gap-2 text-green-800">
              Profesionales adecuados:
            </h3>
            <ul className="list-disc list-inside text-gray-700 text-sm md:text-base mt-2">
              {perfilData.profesionales.map((item, i) => (
                <li key={i} className="text-justify">{item}</li>
              ))}
            </ul>
          </section>

          <section>
            <h3 className="text-base md:text-lg font-semibold flex items-center gap-2 text-purple-800">
              Recomendaciones para casa:
            </h3>
            <ul className="list-disc list-inside text-gray-700 text-sm md:text-base mt-2">
              {perfilData.casa.map((item, i) => (
                <li key={i} className="text-justify">{item}</li>
              ))}
            </ul>
          </section>
        </div>
      </div>

      <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg text-sm text-yellow-900 text-justify">
        <strong className="block font-semibold mb-1">Nota importante: </strong>
        Estas recomendaciones son orientativas y deben ser adaptadas a las necesidades específicas de cada niño. La implementación debe ser supervisada por profesionales especializados para garantizar el mejor desarrollo posible.
      </div>
    </div>
  );
};

export default PerfilCarousel;
